<template>
  <div class="parent-container" v-if="Object.keys(selectedSubmission).length">
    <!-- <v-row class="text-right">
      <v-col align="right">
        <div v-if="isFormEngineLoaded">
          <v-tooltip bottom>
            <template #activator="{ on }">
              <v-btn
                icon
                v-on="on"
                @click="$router.push({ name: 'Dashboard' })"
              >
                <v-icon>cancel</v-icon>
              </v-btn>
            </template>
            <span> Go to Dashboard </span>
          </v-tooltip>
        </div>
      </v-col>
    </v-row> -->
    <div v-if="questions.length">
      <forms-engine-component
        ref="formEngine"
        :form-id="formId"
        rendering-type="section"
        :section-id="selectedSubmission.sections[0].id"
        :sections="selectedSubmission.sections"
        :questions="questions"
        :auth-token="authToken"
        :client-token="clientToken"
        :submission-token="submissionToken"
        :api-url="apiUrl"
        basic-datepicker="false"
        is-guest="false"
        :pubnub-subscribe-key="subscribekey"
        :pubnub-publish-key="publishkey"
        :pubnub-uuid="pubnubuuid"
        @requestingServer="e => this.showSpinner(e)"
        @formMessage="e => this.showFormMessage(e)"
        @formEngineLoaded="e => this.setFormEngineStatus(e)"
      >
      </forms-engine-component>
      <v-row class="mx-2 mb-5 pb-5" v-if="isFormEngineLoaded">
        <v-btn color="primary" large @click="openCancelModal()">Cancel</v-btn>
        <v-spacer />
        <v-btn color="primary" large @click="handleSubmission()">Next</v-btn>
      </v-row>
    </div>

    <v-dialog v-model="cancelModal" :width="400">
      <v-card>
        <v-card-title class="mb-2">Cancel submission?</v-card-title>
        <v-card-subtitle
          >You are about to delete this submission. Are you
          sure?</v-card-subtitle
        >
        <v-card-actions class="text-center mx-0">
          <v-spacer></v-spacer>
          <v-btn text class="mx-2 lighten-1" @click="cancelModal = false"
            >No</v-btn
          >
          <v-btn text class="mx-2 lighten-1" @click="cancel">Yes</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import uiHelper from '@/helpers/ui'
import { mapGetters, mapActions, mapMutations } from 'vuex'

export default {
  name: 'CreateNewSubmission',

  components: {},

  data() {
    return {
      cancelModal: false,
      cancellingForm: false,
      isFormEngineLoaded: false
    }
  },

  computed: {
    ...mapGetters({
      selectedSubmission: 'form/selectedSubmission',
      submissionToken: 'form/selectedSubmissionToken',
      authToken: 'auth/authToken',
      clientToken: 'user/clientToken'
    }),

    questions() {
      if (this.selectedSubmission.sections[0].hasOwnProperty('questions')) {
        return this.selectedSubmission.sections[0].questions
      }
      return []
    },

    gridConfig() {
      return this.selectedSubmission.sections[0].layout_config.style
    },

    formId() {
      return this.selectedSubmission.id
    },
    apiUrl() {
      return process.env.VUE_APP_FORMS_URL
    },
    subscribekey() {
      return process.env.VUE_APP_PUBNUB_SUBSCRIBE_KEY
    },
    publishkey() {
      return process.env.VUE_APP_PUBNUB_PUBLISH_KEY
    },
    pubnubuuid() {
      return process.env.VUE_APP_PUBNUB_UUID
    }
  },

  methods: {
    ...mapActions({
      cancelSubmission: 'form/cancelSubmission',
      getOpenSubmissions: 'form/getOpenSubmissions'
    }),
    ...mapMutations({
      setSelectedSubmissionSection: 'form/setSelectedSubmissionSection',
      setSelectedSubmissionDetails: 'form/setSelectedSubmissionDetails'
    }),

    async handleSubmission() {
      if (await this.$refs.formEngine._validate()) {
        try {
          let response = await this.getOpenSubmissions({})
          let submissionDetails = response.data.payload.submissions[0]
          this.setSelectedSubmissionDetails(submissionDetails)
        } catch (e) {
          uiHelper.showSnackbarMessage(e.response.data.msg, 'error')
        }
        this.$router.push({
          name: 'Submission',
          params: { id: this.submissionToken }
        })
      } else {
        uiHelper.showSnackbarMessage('Please fill required fields', 'error')
      }
    },
    async cancel() {
      this.cancellingForm = true
      let response = await this.cancelSubmission(this.formId)
      if (response) {
        uiHelper.showSnackbarMessage(response.data.msg)
      }
      this.$router.push({ name: 'Dashboard' })
    },
    showSpinner(e) {
      if (e.detail) uiHelper.progressBarStatus(true)
      else if (!e.detail) uiHelper.progressBarStatus(false)
    },

    showFormMessage(e) {
      uiHelper.showSnackbarMessage(e.detail.message, e.detail.type)
    },

    setFormEngineStatus(e) {
      this.isFormEngineLoaded = e.detail
    },
    openCancelModal() {
      this.cancelModal = true
    }
  }

  // async beforeRouteLeave(to, from, next) {
  //   if (!this.cancellingForm) {
  //     if (await this.$refs.formEngine._validate()) {
  //       next()
  //     } else {
  //       next(false)
  //       uiHelper.progressBarStatus(false)
  //     }
  //   } else {
  //     next()
  //   }
  // }
}
</script>

<style scoped>
.parent-container {
  margin-left: 150px;
  margin-right: 150px;
}
</style>
